// // SearchDropdown.js
// import React, { useState, useEffect, useRef } from 'react';

// const SearchDropdown = ({
//   initialOptions,
//   onSelect,
//   onInputChange,
//   labelKey = () => "",
//   className,
//   dropdownStyle,
//   inputStyle,
//   optionStyle,
//   optionClassName,
//   label,
// }) => {
//   const [options, setOptions] = useState(initialOptions);
//   const [showOptions, setShowOptions] = useState(false);
//   const dropdownRef = useRef(null); // Add this line

//   useEffect(() => {
//     setOptions(initialOptions); // Update the options state when initialOptions changes
//   }, [initialOptions]);

//   // Add this useEffect hook
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
//         setShowOptions(false);
//       }
//     };

//     document.addEventListener('mousedown', handleClickOutside);
//     return () => {
//       document.removeEventListener('mousedown', handleClickOutside);
//     };
//   }, []);

//   const handleSelect = (option) => {
//     onSelect(option);
//     setShowOptions(false);
//   };

//   return (
//     <div className={className} ref={dropdownRef}> {/* Add the ref here */}
//       <label>{label}</label>
//       <br />
//       <input
//         type="text"
//         style={inputStyle}
//         className={className}
//         onChange={(e) => {
//           onInputChange(e.target.value);
//           setShowOptions(true);
//         }}
//       />
//       {showOptions && (
//         <div style={dropdownStyle}>
//           {options.map((option, index) => (
//             <div
//               key={index}
//               onClick={() => handleSelect(option)}
//               style={optionStyle}
//               className={optionClassName}
//             >
//               {labelKey(option)}
//             </div>
//           ))}
//         </div>
//       )}
//     </div>
//   );
// };

// export default SearchDropdown;















import { useState, useEffect, useRef } from 'react';

const SearchDropdown = ({
  initialOptions,
  onSelect,
  onInputChange,
  labelKey = () => "",
  className,
  dropdownStyle,
  inputStyle,
  optionStyle,
  optionClassName,
  label,
}) => {
  const [options, setOptions] = useState(initialOptions || []);
  const [showOptions, setShowOptions] = useState(false);
  const [inputValue, setInputValue] = useState(""); // controlled input value
  const dropdownRef = useRef(null);

  useEffect(() => {
    setOptions(initialOptions || []); // update options when parent provides new ones
  }, [initialOptions]);

  // close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    onSelect(option);
    // clear the input when an option is selected so typed text vanishes
    setInputValue("");
    // also inform parent that input changed (optional, keeps parent searchKey in sync)
    if (typeof onInputChange === "function") onInputChange("");
    setShowOptions(false);
  };

  const handleChange = (e) => {
    const val = e.target.value;
    setInputValue(val);
    if (typeof onInputChange === "function") onInputChange(val);
    // open options only when user has typed something (or you can always open)
    setShowOptions(true);
  };

  return (
    <div className={className} ref={dropdownRef} style={{ position: "relative" }}>
      {label && <label>{label}</label>}
      <br />
      <input
        type="text"
        value={inputValue}
        onChange={handleChange}
        style={inputStyle}
        className={className}
        onFocus={() => setShowOptions(true)}
        autoComplete="off"
      />
      {showOptions && options && options.length > 0 && (
        <div style={dropdownStyle}>
          {options.map((option, index) => (
            <div
              key={index}
              onClick={() => handleSelect(option)}
              style={optionStyle}
              className={optionClassName}
            >
              {labelKey(option)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default SearchDropdown;
